<template>
    <div>
        <div class="card">
			<div class="card__header">
				<div class="card__title">Вывод средств</div>
			</div>
			<div class="card__body">
				<div class="withdraw">

					<PaymentSystems v-if="types.length" :items="types" :selected-type="selectedType" @set-type="setType"/>

					<div class="fields__item field-input__label" v-if="selectedType && selectedType.currency">
						<span class="badge badge--secondary">
							1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
						</span>
					</div>

					<div class="fields__item field-input" v-if="selectedType?.banks?.length">
						<label class="text-field__label">Банк</label>
						<FieldSelect :options="selectedType.banks" placeholder="Выберите банк" @update:model-value="handlerSetBank"/>
					</div>

					<div v-if="selectedType && selectedType.currency" class="fields__item">
						<span class="badge badge--secondary">
							Курс: {{ $root.currency(selectedType.currency) }}
						</span>
					</div>

					<div class="fields__item">
						<label class="text-field__label">Реквизиты</label>
						<div class="text-field">
							<input type="text"
								   class="text-field__input"
								   v-model="wallet"
								   placeholder="Введите реквизиты">
						</div>
					</div>

					<div class="fields__item">
						<label class="text-field__label">
							Сумма <span v-if="selectedType">от {{ $root.currency(selectedType.min_amount) }} до {{ $root.currency(selectedType.max_amount) }}</span>
						</label>
						<div class="text-field">
							<input type="number"
								   class="text-field__input"
								   v-model="amount"
								   placeholder="Введите сумму"
								   @input="validateSum">
						</div>
						<div class="text-field__note" v-if="selectedType">
							<span class="badge badge--secondary">
							Комиссия: {{ selectedType.commission }}%
							</span>
						</div>
					</div>

					<button :disabled="!canSendWithdraw" @click="withdrawSock" class="btn btn--primary btn--block fields__item">
						Вывести
					</button>

					<Loader v-show="loader" :loading="loader" static/>
				</div>
			</div>

			<div class="table-wrap" v-if="withdraws.length">
				<table class="table">
					<tbody>
						<tr v-for="withdraw in withdraws">
							<td width="40px">
								<img class="withdraw__table-img" :src="withdraw.icon">
							</td>
							<td>
								<div>
									<b>{{ withdraw.id }}</b>
								</div>
								<div class="small text-muted">
									{{ withdraw.date }}
								</div>
							</td>
							<td>
								<div>
									<b>{{ $root.currency(withdraw.amount) }}</b>
								</div>
								<div class="small text-muted">
									{{ withdraw.wallet }}
								</div>
							</td>
							<td class="text-right">
								<span class="badge badge--lg badge--warning-light" v-if="withdraw.status === 'performed' || withdraw.status === 'pending' || withdraw.status === 'deferred'">
									<svg class="badge__icon"><use href="#svg-icon-time"></use></svg>
									В обработке
								</span>
								<span class="badge badge--lg badge--success-light" v-if="withdraw.status === 'processed'">
									<svg class="badge__icon"><use href="#svg-icon-checkmark"></use></svg>
									Выполнено
								</span>
								<span class="badge badge--lg badge--danger-light" v-if="withdraw.status === 'canceled' || withdraw.status === 'failed'">
									<svg class="badge__icon"><use href="#svg-icon-close"></use></svg>
									Отменено
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
            <div class="withdraw__more" v-show="page < totalPages" @click="getMoreWithdraws">
				<span v-show="!loader">
					<svg width="22" height="22"><use href="#svg-icon-dots"></use></svg>
				</span>
				<Loader v-show="loader" :loading="loader" static/>
            </div>
        </div>
    </div>
</template>

<script>
	import FieldSelect from "../../components/blocks/FieldSelect.vue";
	import PaymentSystems from "../../components/blocks/PaymentSystems.vue";
	import { useUserStore } from '../../stores/User';
	import { mapState } from 'pinia';
	import Loader from "../../components/blocks/Loader.vue";

	export default {
		components: {
			Loader,
			PaymentSystems,
			FieldSelect
		},

        data() {
            return {
                loader: false,
                amount: null,
                wallet: null,
                types: [],
                selectedType: false,
                page: 1,
                disableBtn: false,
                withdraws: [],
                totalPages: 0,
                showAddForm: false,
				selectedBank: null
            }
        },
        computed: {
			...mapState(useUserStore, ['user']),

            canSendWithdraw: function () {
				return this.selectedType && this.wallet && this.amount && !this.selectedType.banks.length || this.selectedType && this.wallet && this.amount && this.selectedType.banks.length && this.selectedBank;
            }
        },
        mounted() {
            this.getTypes();
            this.getWithdraws();
        },
        methods: {
            validateSum() {
                this.amount = this.amount.toString();
                this.amount = this.amount.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
            }, 
            withdrawSock() {
                this.amount = Math.round(this.amount);
                this.amount = parseInt(this.amount, 10);

                if (!this.wallet) {
                    return this.$toast.error('Укажите реквизиты');
                }

                if(!this.selectedType) {
                    return this.$toast.error('Выберите способ вывода');
                }

                if(!this.amount) {
                    return this.$toast.error('Укажите сумму вывода');
                }

				if(!this.wallet) {
					return this.$toast.error('Укажите реквизиты');
				}

                if (this.amount < this.selectedType.min_amount) {
                    return this.$toast.error(`Минимальная сумма вывода для данного способа ${this.selectedType.min_amount}`);
                }

                if (this.amount > this.selectedType.max_amount) {
                    return this.$toast.error(`Максимальная сумма вывода для данного способа ${this.selectedType.max_amount}`);
                }

                if(this.amount > this.user.balance) {
                    return this.$toast.error('На вашем балансе недостаточно средств');
                }

				if(this.selectedType.banks.length && !this.selectedBank) {
					return this.$toast.error('Необходимо выбрать банк для вывода средств');
				}

                // if(!this.user.has_pin) {
                //     return this.$toast.error('Для вывода средств требуется установить PIN-код в разделе настройки');
                // }

                // if(this.user.pin_expire_timestamp <= Date.now() / 1000) {
                //     return this.$root.emitter.emit('showPin');
                // }

                if (this.disableBtn) {
                    return;
                }

                this.disableBtn = true;

                this.$root.axios.post('/api/withdraws', {
                    amount: this.amount,
                    type_id: this.selectedType.id,
                    wallet: this.wallet,
					bank_id: this.selectedBank
                }).then(res => {
                    this.user.balance = res.data.balance;
                    this.$toast.success(res.data.message);

                    this.amount = null;
                    this.wallet = null;
					this.selectedBank = null;
                    this.page = 1;

                    this.getWithdraws();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });

				this.disableBtn = false;
            },
			getWithdraws() {
				this.loader = true;

				this.$root.axios.get('/api/withdraws', {
					params: {
						page: this.page
					}
				}).then(res => {
					this.withdraws = this.withdraws.concat(res.data.withdraws);
					this.totalPages = res.data.total_pages;
					this.disableBtn = false;
				}).catch(error => {
					this.$toast.error(this.$root.graphql.axiosGetError(error));
					this.disableBtn = false;
				});

				this.loader = false;
			},
            getTypes() {
                this.$root.axios.get('api/withdraw/types')
                .then(res => {
                    this.types = res.data;
                })
                .catch(error => {
                    this.$router.push({name: 'index'});
                    this.$root.isLoading = false;
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            setType(type) {
				this.selectedType = type;
				this.selectedBank = null;

                // if(this.selectedType.wallets.length === 1) {
                //     this.setWallet(this.selectedType.wallets[0].id);
                // }
            },
            getMoreWithdraws() {
                if(this.page >= this.totalPages) {
                    this.loader = false;
                    return;
                }

                this.page += 1;
                this.loader = true;
                this.getWithdraws();
            },
            setWallet(walletId) {
                this.selectedWallet = walletId;
            },
            saveWallet() {
                if(!this.selectedType) {
                    return this.$toast.error('Выберите платежную систему');
                }

                if(!this.wallet) {
                    return this.$toast.error('Укажите реквизиты платежной системы');
                }

                this.$root.axios.post('/api/wallet/store', {
                    withdraw_type_id: this.selectedType.id,
                    wallet: this.wallet
                }).then(res => {
                    this.getTypes();
                    
                    this.wallet = null;
                    this.selectedType = false;
                    this.selectedWallet = false;

                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
			handlerSetBank(bank) {
				if (bank) {
					this.selectedBank = bank.id;
				}
			}
        },
        sockets: {
            withdraw_complete: function() {
                this.page = 1;
                this.loader = true;

                this.getWithdraws();
            }
        }
    }
</script>